const getDefaultState = () => ({
  created: false,
  sinisterId: null,
  secondaryId: null,
  address: null,
  zipCode: null,
  coordinates: null,
  moreThanTwoYears: null,
  propertyType: '',
  residentType: '',
  observations: '',
  sinisterSummary: [],
  materialSummary: {},
  report: [],
  forms: [],
  lastSelectedValue: '',
  lastSelectedKey: '',
  damagedItem: '',
  selectedDamagedParts: [],
  counterMurs: 1,
  warrantyId: '',
  damagedPartKey: '',
  damagedItemKey: '',
  categoryId: '',
  subtypeId: '',
  damagesCategories: [],
  categoriesQty: null,
  categoriesMobilier: null,
  literalsMobilier: {},
  textInputSearchMobilier: '',
  categoryFinalLevel: false,
  keysMobilier: {},
  productIdUptecFeature: null,
  objUptec: {},
  resultDeclaration: null,
  damageTypeLiteral: '',
  hasUpptecDamage: false,
  isMultidamage: false,
  multidamage: {},
  maxPiecesId: [],
  repDeclaration: null,
  inmobilier: null,
  warranties: {}
})

export { getDefaultState }
